"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Airports = /** @class */ (function () {
    function Airports(data) {
        this.list = [];
        if (!!data) {
            var init = function (gateway) { return ({
                directionMap: new Map(),
                flightClassMap: new Map(),
                locCd: gateway.locCd,
                locName: gateway.locName,
            }); };
            var add = function (map, key, value) {
                if (!map.has(key)) {
                    map.set(key, []);
                }
                map.get(key).push(value);
            };
            var _loop_1 = function (gateway) {
                var airport = this_1.list.find(function (airport) { return airport.locCd === gateway.locCd; });
                if (!airport) {
                    airport = init(gateway);
                    this_1.list.push(airport);
                }
                add(airport.directionMap, gateway.direction, gateway.flightClass);
                add(airport.flightClassMap, gateway.flightClass, gateway.direction);
            };
            var this_1 = this;
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var gateway = data_1[_i];
                _loop_1(gateway);
            }
            this.list.sort(function (a, b) { return a.locName.localeCompare(b.locName, 'de'); });
        }
    }
    return Airports;
}());
exports.Airports = Airports;
//# sourceMappingURL=airports.js.map